import React, { Fragment } from 'react'
import styled from 'styled-components'
import LicenceModal from '../LicenceModal'

export default class ArticlesList extends React.Component {
  state = {
    modalOpen: false,
  }

  toggleModal = () => this.setState({ modalOpen: !this.state.modalOpen })

  render() {
    const { articles, openArticle } = this.props
    const { modalOpen } = this.state

    return (
      <Fragment>
        {modalOpen && <LicenceModal onClose={this.toggleModal}/>}
        <Container>
          {
            articles.map((article, i) => (
              <Article
                key={i}
                background={article.image}
                onClick={() => !article.disabled ? openArticle(article.id) : this.toggleModal()}
                disabled={article.disabled}
              >
                <Icon src={article.icon}/>
                <Title>{article.name}</Title>
                <Description>{article.title}</Description>
              </Article>
            ))
          }
        </Container>
      </Fragment>
    )

  }
}

const Container = styled.div`
  display: flex;
  flex-flow: wrap;
  
  @media all and (max-width: 700px) {
    flex-direction: column;
  }
`

const Article = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: ${({ theme }) => theme.primaryGradient};
  height: 170px;
  flex-basis: 45%;
  margin-bottom: 1rem;
  border-radius: 5px;
  padding: 1rem;
  color: #fff;
  cursor: pointer;
  opacity: ${(props) => props.disabled ? '.5' : '.9'};
  transition: all .2s linear;
  
  &:hover {
    opacity: ${(props) => props.disabled ? '.5' : '1'};
  }
  
  &:nth-of-type(n+1) {
    margin-right: 1rem;
    
    @media all and (max-width: 700px) {
      margin-right: 0;
    }
  }
  
  @media all and (max-width: 700px) {
    flex-basis: 100%;
  }
`

const Icon = styled.img`
  width: 48px;
`

const Title = styled.h4`
  margin: .7rem 0;
`

const Description = styled.p`

`
